import { DocumenterMethod } from './documenter-method.enum';
import { SystemDetails } from './system-details';
import { EvidenceTool } from './user';

const EVIDENCE_TOOL_BY_DOCUMENTER_METHOD: Record<DocumenterMethod, EvidenceTool> = {
    [DocumenterMethod.PLAYER_2_0]: EvidenceTool.RECORDER_2_0,
    [DocumenterMethod.VIDEO_RECORDER]: EvidenceTool.VIDEO_RECORDER,
    [DocumenterMethod.TEST_AUTOMATION_RECORDER]: EvidenceTool.LOCOTA
};

type ConcreteEvidenceTool = Exclude<EvidenceTool, EvidenceTool.SYSTEM_DEFAULT>;

type EvidenceMethodFlag = 'recorder2_0EvidenceEnabled' | 'videoRecorderEvidenceEnabled' | 'testAutomationRecorderEvidenceEnabled';

const ENABLED_FLAG_BY_EVIDENCE_TOOL: Record<ConcreteEvidenceTool, EvidenceMethodFlag> = {
    [EvidenceTool.RECORDER_2_0]: 'recorder2_0EvidenceEnabled',
    [EvidenceTool.VIDEO_RECORDER]: 'videoRecorderEvidenceEnabled',
    [EvidenceTool.LOCOTA]: 'testAutomationRecorderEvidenceEnabled'
};

function systemDefaultEvidenceTool(systemDetails: SystemDetails): EvidenceTool {
    return EVIDENCE_TOOL_BY_DOCUMENTER_METHOD[systemDetails.defaultDocumenterMethod];
}

function isEvidenceToolEnabled(evidenceTool: ConcreteEvidenceTool, systemDetails: SystemDetails): boolean {
    return systemDetails[ENABLED_FLAG_BY_EVIDENCE_TOOL[evidenceTool]];
}

export function resolveEvidenceTool(userEvidenceTool: EvidenceTool, systemDetails: SystemDetails | undefined): EvidenceTool {
    if (!systemDetails) {
        return userEvidenceTool;
    }

    if (userEvidenceTool === EvidenceTool.SYSTEM_DEFAULT) {
        return systemDefaultEvidenceTool(systemDetails);
    }

    if (isEvidenceToolEnabled(userEvidenceTool, systemDetails)) {
        return userEvidenceTool;
    }

    return systemDefaultEvidenceTool(systemDetails);
}
